import { API_KEYS, Api } from './base.api';
import { SCOPE_TYPE } from './utils';

export const homechargerApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    deleteHomeCharger: builder.mutation<any, { id: string; name: string; scope: SCOPE_TYPE }>({
      query: (payload) => ({
        url: `/provision/charger/${payload.id}`,
        params: { scope: payload.scope },
        method: 'DELETE',
        toast: {
          successTrans: 'charger_delete_success_toast_message',
          failedTrans: 'charger_delete_error_toast_message',
          values: {
            chargerName: payload.name,
          },
        },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: API_KEYS.CHARGERS, id: 'LIST' },
        { type: API_KEYS.LOCATION, id: 'LIST' },
        { type: API_KEYS.PAYMENT_TERMINALS_COMBINED, id: 'LIST' },
      ],
    }),
  }),
});

export const { useDeleteHomeChargerMutation } = homechargerApi;
